import Button from '../components/Button'
import Page from '../components/Page'
import Section from '../components/Section'
import { Text } from '../components/Text'

export default function NotFound() {
  return (
    <Page>
      <Section
        withVerticalPadding
        className='flex flex-1 py-36 md:py-60 min-h-screen md:min-h-auto'
      >
        <div className={'flex w-full flex-col gap-y-11 tracking-[0px] pt-[120px]'}>
          <div className='flex flex-col gap-y-3'>
            <Text.H1 underline={'off'}>
              <Text.Gradient>404</Text.Gradient>
            </Text.H1>
            <Text.H1>Not Found</Text.H1>
          </div>
          <Text.Body>
            There is nothing here. Maybe the page you’re looking for is not found or never existed!
          </Text.Body>
          <div className='flex items-end pt-[76px]'>
            <Button href='/' variant='outline' icon='ArrowBack' iconPosition='left'>
              Back to Home
            </Button>
          </div>
        </div>
      </Section>
    </Page>
  )
}
